import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Routes } from './components/Routes/Routes';
import './i18n';
ReactDOM.render(React.createElement(Routes, null), document.getElementById('body'));
